export const X_SCALAR_COOKIE = 'x-scalar-cookie';
export const X_SCALAR_SET_COOKIE = 'x-scalar-set-cookie';
export const X_SCALAR_USER_AGENT = 'x-scalar-user-agent';
export const X_SCALAR_DATE = 'x-scalar-date';
export const X_SCALAR_DNT = 'x-scalar-dnt';
export const X_SCALAR_REFERER = 'x-scalar-referer';
